import { createFeature, createReducer, on } from '@ngrx/store';

import { QuestionActions } from './question.actions';
import { QuestionState } from './question-state.model';

const initialState: QuestionState = {
  questions: [],
  search: '',
  isLoading: false,
  error: null,

  selectedId: null,
  detail: null,
  isDetailLoading: false,

  companies: [],
  categories: [],

  parentQuestionSearchResults: [],
  childQuestionSearchResults: [],
};

export const questionFeatureKey = 'questions';

export const questionsReducer = createReducer(
  initialState,

  on(QuestionActions.loadQuestions, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(QuestionActions.loadQuestionsSuccess, (state, { questions }) => ({
    ...state,
    isLoading: false,
    error: null,
    questions,
  })),
  on(QuestionActions.loadQuestionsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(QuestionActions.setSearch, (state, { search }) => ({
    ...state,
    search,
    error: null,
    isLoading: true,
  })),

  on(QuestionActions.selectQuestion, (state, { id }) => ({
    ...state,
    selectedId: id,
    detail: null,
    isDetailLoading: true,
    error: null,
  })),
  on(QuestionActions.deselectQuestion, (state) => ({
    ...state,
    selectedId: null,
    detail: null,
    isDetailLoading: false,
  })),

  on(QuestionActions.loadDetailSuccess, (state, { detail }) => ({
    ...state,
    isDetailLoading: false,
    detail,
    error: null,
  })),
  on(QuestionActions.loadDetailFailure, (state, { error }) => ({
    ...state,
    isDetailLoading: false,
    error,
  })),

  on(QuestionActions.createQuestion, (state) => ({
    ...state,
    isDetailLoading: true,
    error: null,
  })),
  on(QuestionActions.createQuestionSuccess, (state) => ({
    ...state,
    isDetailLoading: false,
    detail: null,
    selectedId: null,
    error: null,
  })),
  on(QuestionActions.createQuestionFailure, (state, { error }) => ({
    ...state,
    isDetailLoading: false,
    error,
  })),

  on(QuestionActions.updateQuestion, (state) => ({
    ...state,
    isDetailLoading: true,
    error: null,
  })),
  on(QuestionActions.updateQuestionSuccess, (state) => ({
    ...state,
    isDetailLoading: false,
    error: null,
  })),
  on(QuestionActions.updateQuestionFailure, (state, { error }) => ({
    ...state,
    isDetailLoading: false,
    error,
  })),

  on(QuestionActions.deleteQuestion, (state) => ({
    ...state,
    isDetailLoading: true,
    error: null,
  })),
  on(QuestionActions.deleteQuestionSuccess, (state) => ({
    ...state,
    isDetailLoading: false,
    detail: null,
    selectedId: null,
    error: null,
  })),
  on(QuestionActions.deleteQuestionFailure, (state, { error }) => ({
    ...state,
    isDetailLoading: false,
    error,
  })),

  on(QuestionActions.deleteLocalization, (state) => ({
    ...state,
    error: null,
  })),
  on(QuestionActions.deleteLocalizationSuccess, (state, { locale }) => ({
    ...state,
    error: null,
    detail: state.detail && {
      ...state.detail,
      localizations: state.detail.localizations.filter(
        (localization) => localization.locale !== locale,
      ),
    },
  })),
  on(QuestionActions.deleteLocalizationFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(QuestionActions.loadCompanies, (state) => ({
    ...state,
    error: null,
  })),
  on(QuestionActions.loadCompaniesSuccess, (state, { companies }) => ({
    ...state,
    companies,
    error: null,
  })),
  on(QuestionActions.loadCompaniesFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(QuestionActions.loadCategories, (state) => ({
    ...state,
    error: null,
  })),
  on(QuestionActions.loadCategoriesSuccess, (state, { categories }) => ({
    ...state,
    categories,
    error: null,
  })),
  on(QuestionActions.loadCategoriesFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(QuestionActions.searchParentQuestionsSuccess, (state, { results }) => ({
    ...state,
    parentQuestionSearchResults: results,
  })),

  on(QuestionActions.searchChildQuestionsSuccess, (state, { results }) => ({
    ...state,
    childQuestionSearchResults: results,
  })),

  on(QuestionActions.resetState, () => initialState),
);

export const questionFeature = createFeature({
  name: questionFeatureKey,
  reducer: questionsReducer,
});
